export default "__VITE_ASSET__TrjYvohV__"